import { Colors } from '../consts/Colors.js';
import AbstractScene from './AbstractScene.js';

// Prefabs
import ButtonRounded from '../prefabs/ButtonRounded.js';
import MissionTitle from '../prefabs/MissionTitre.js';
import NavTitre from '../prefabs/NavTitre.js';
import BlueMessageBox from '../prefabs/BlueMessageBox.js';
import BurgerMenu from '../prefabs/BurgerMenu.js';
import SwapActivity from '../prefabs/Swape.js';
import Fish from '../prefabs/Fish.js';
import AnswerFeedBack from '../prefabs/AnswerFeedBack.js';

// Data
import menacemystereData from '../data/Mission4.js';
import { Sizes } from '../consts/Sizes.js';
import { tags } from '../consts/Tags.js';
import { wrap } from 'lodash';

export default class Mission4 extends AbstractScene {
    constructor() {
        super({
            key: 'Mission4',
        });
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
        this.load.image('backLabyrinthe', 'assets/images/activite-4/back-labyrinthe.png');
        this.allFilets = [];
        this.fishData = menacemystereData[0].fishData;
        this.clickableData = menacemystereData[0].clickable;
        this.isFirstTime = true;
        this.videoKey = 'chaineAlimentaireVideo';
        this.preTarget = () => this.scene.start('Mission3');
        this.postTarget = () => {
            this.showIntro();
        };
        this.allControls = [];
    }

    update() {
        super.update();
    }

    create() {
        this.cameras.main.setBackgroundColor(Colors.Elmt.DarkBlue);
        this.cameras.main.fadeIn(1000);
        // mission data
        this.missionData = this.getMissionData(menacemystereData);

        this.videoKey = this.getText('Mission4', 'videoKey');

        this.showVideoLoading(this.videoKey, () => {
            this.showVideo(this.videoKey); // une fois chargée, on affiche et on contrôle
        });
    }
    addConsigne() {
        this.isClosing = false;
        const elementsToAnimate = [];

        // add cadre consigne
        const cadre = this.add
            .image(this.width / 2, this.height / 2, 'cadre-consigne-activite-1')
            .setOrigin(0.5, 0.5)
            .setScale(0);
        elementsToAnimate.push(cadre);

        // add consigne text
        const texte = new BlueMessageBox(
            this,
            this.cameras.main.centerX,
            450,
            this.game.data.level === 0
                ? this.getText('Mission4', 'consigneNiveau0')
                : this.getText('Mission4', 'consigneNiveau1')
        );

        // add icone close
        const close = this.add
            .image(this.width / 2, 70 * 2 + 64 / 2, 'cta-close')
            .setOrigin(0.5, 0.5)
            .setScale(0)
            .setInteractive({ cursor: 'pointer' })
            .on('pointerdown', () => {
                if (this.isClosing) return; // ⛔ empêche de recliquer
                this.isClosing = true;

                this.input.enabled = false;

                const elementsToHide = [cadre, texte, close, loupe];
                let completed = 0;

                elementsToHide.forEach((el) => {
                    this.tweens.add({
                        targets: el,
                        scale: 0,
                        duration: 300,
                        ease: 'Back.easeIn',
                        onComplete: () => {
                            completed++;
                            if (completed === elementsToHide.length) {
                                cadre.destroy();
                                texte.destroy();
                                close.destroy();
                                loupe.destroy();

                                // quand tous les éléments ont disparu, on relance l'activité
                                this.game.data.level === 0
                                    ? this.addSwape()
                                    : this.addPopupRecherche();

                                // Réinitialise le flag si besoin pour autoriser plus tard
                                this.isClosing = false;

                                // this.input.enabled = true;
                            }
                        },
                    });
                });
            });

        elementsToAnimate.push(close);

        // icone consigne
        const loupe = this.add
            .image(
                266 * this.scaleX + 50,
                112 * 2 + 122 / 2 + 20,
                this.game.data.level === 0 ? 'consigne-activite-4' : 'consigne-activite-4b'
            )
            .setOrigin(0.5, 0.5)
            .setScale(0);
        elementsToAnimate.push(loupe);

        // Appliquer l'animation scale up avec rebound
        elementsToAnimate.forEach((el, index) => {
            this.tweens.add({
                targets: el,
                scale: 1,
                duration: 500,
                ease: 'Back.Out',
                delay: index * 100, // léger décalage pour un effet en cascade
            });
        });
    }

    showIntro() {
        this.sceneContainer = this.add.container(this.width / 2, this.height / 2);

        // background
        this.background = this.add.image(0, 0, 'background-activite-4').setOrigin(0.5);

        this.sceneContainer.add(this.background);

        const navTitre = this.add.existing(
            new NavTitre(this, 200, 0, '4', this.getText('Mission4', 'titre'), this.scaleX)
        );

        navTitre.showWithAnimation();

        // Fog (créé invisible au départ)
        const fog = this.add.graphics();
        const containerWidth = this.sceneContainer.width || this.scale.width;
        const containerHeight = this.sceneContainer.height || this.scale.height;

        const fogStartY = containerHeight * 0.5 - containerHeight / 2;
        const fogEndY = containerHeight / 2;
        const fogHeight = fogEndY - fogStartY;

        for (let i = 0; i < fogHeight; i++) {
            const alpha = (i / fogHeight) * 0.8;
            fog.fillStyle(Colors.Elmt.DarkBlue, alpha);
            fog.fillRect(-containerWidth / 2, fogStartY + i, containerWidth, 1);
        }

        this.sceneContainer.add(fog);

        // MissionTitle au-dessus
        this.missionTitle = new MissionTitle(
            this,
            0,
            0,
            4,
            this.getText('Mission4', 'mission'),
            this.getText('Mission4', 'titre'),
            this.getText('Mission4', 'intro'),
            this.scaleX
        );
        this.missionTitle.setDepth(2);

        this.sceneContainer.add(this.missionTitle);
        // Bouton
        const button = this.add.existing(
            new ButtonRounded(
                this,
                458 * this.scaleX + 86,
                this.cameras.main.height - 32 - 32,
                86 * 2,
                32 * 2,
                this.getText('Mission4', 'buttonLabel1'),
                Colors.Text.DarkBlue,
                Colors.Elmt.White,
                false,
                Colors.Text.White,
                true,
                false,
                'arrow-right',
                null
            )
        );
        button.setAlpha(0); // Start invisible

        // ▶️ Sequence d'animations
        this.missionTitle.animateIn(); // Animation du titre de la mission

        this.tweens.add({
            targets: button,
            alpha: 1,
            duration: 1000,
            ease: 'Sine.easeIn',
        });

        this.uiElements = [fog, this.missionTitle, button];
        button.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            this.input.enabled = false;
            // Fade out tout sauf la nav
            this.tweens.add({
                targets: this.uiElements,
                alpha: 0,
                duration: 500,
                onComplete: () => {
                    this.tweens.add({
                        targets: this.background,
                        alpha: 0,
                        duration: 500,
                        onComplete: () => {
                            this.background.setTexture('background-activite-2b').setOrigin(0, 0);
                            this.background.y = -this.height;
                            this.background.x = -this.width / 2;
                            this.tweens.add({
                                targets: this.background,
                                alpha: 1,
                                duration: 500,
                                onComplete: () => {
                                    this.addConsigne();
                                    this.input.enabled = true;
                                },
                            });
                        },
                    });
                },
            });
        });
    }

    addSwape() {
        this.input.enabled = true;
        const images = ['img-crabe-1', 'img-crabe-2', 'img-crabe-3', 'img-crabe-4', 'img-crabe-5'];

        const letters = [
            this.getText('Mission4', 'lettre1'),
            this.getText('Mission4', 'lettre2'),
            this.getText('Mission4', 'lettre3'),
            this.getText('Mission4', 'lettre4'),
            this.getText('Mission4', 'lettre5'),
        ];
        const reponse = [
            this.getText('Mission4', 'reponse1'),
            this.getText('Mission4', 'reponse2'),
            this.getText('Mission4', 'reponse3'),
            this.getText('Mission4', 'reponse4'),
            this.getText('Mission4', 'reponse5'),
        ];

        this.swapGame = new SwapActivity(this, 380, 250, images, letters, reponse);

        this.bouteilleActivite = this.add.image(
            this.width - 250,
            this.height - 70,
            this.getText('Mission4', 'bouteilleVideImage')
        );
        this.addBurgerMenu(5);
    }

    addChalutier() {
        this.sceneContainer.add(this.background);
        this.chalutier = this.add
            .image(this.width / 2, 240, 'bateau-chalutier')
            .setOrigin(0.5)
            .setScale(1.5);
        this.allFilets.push(this.chalutier);
    }

    addPopupRecherche() {
        this.addChalutier();
        this.isDebriefActive = true;
        this.isAnimating = false;
        this.firstTime = true;
        const container = this.add
            .image(this.width / 2 - 823 / 2, this.height / 2, 'container-activite-4')
            .setOrigin(0, 0.5)
            .setDepth(1);

        this.imageRecherche = this.add
            .image(162 * this.scaleX + 80, this.height / 2 - 10, `chalutier`)
            .setScale(1)
            .setOrigin(0.5)
            .setDepth(1);

        const descText = this.add
            .rexTagText(
                container.x + 823 / 2 - 130,
                container.y - container.height / 2 + 70,
                this.getText('Mission4', 'info1'),
                {
                    wordWrap: { width: 300 * 2 },
                    fontSize: Sizes.Text.p,
                    fontFamily: 'Monteserrat',
                    color: Colors.Text.Black,
                    backgroundColor: 'transparent',
                    tags: tags,
                    lineSpacing: 2,
                }
            )
            .setDepth(1);

        const closeButton = this.add
            .image(this.width / 2 - 8, 86 * 2, 'cta-close')
            .setOrigin(0.5)
            .setDepth(1);

        const minimize = () => {
            if (this.isAnimating) return;
            this.isAnimating = true;

            this.isDebriefActive = false;

            // Animation de disparition du popup
            this.tweens.add({
                targets: [closeButton, container, descText],
                alpha: 0,
                scale: 0,
                duration: 300,
                ease: 'Sine.easeInOut',
            });

            this.tweens.add({
                targets: this.imageRecherche,
                scale: 0.5,
                x: 64 + 54 * 2,
                y: this.height - 100,
                duration: 500,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                    this.imageRecherche.setInteractive({ cursor: 'pointer' });
                    this.isAnimating = false;

                    if (this.firstTime) {
                        this.addActivite();
                        this.firstTime = false;
                    }
                },
            });
        };

        const maximize = () => {
            if (this.isAnimating) return;
            this.isAnimating = true;

            this.tweens.add({
                targets: this.imageRecherche,
                scale: 1,
                x: 162 * this.scaleX + 80,
                y: this.height / 2 - 10,
                duration: 500,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                    this.tweens.add({
                        targets: [closeButton, container, descText],
                        scale: 1,
                        alpha: 1,
                        duration: 300,
                        ease: 'Sine.easeInOut',
                        onComplete: () => {
                            this.isAnimating = false; // Réactive le clic
                        },
                    });
                },
            });
        };

        closeButton.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            minimize();
        });

        this.imageRecherche
            .setScale(0.5)
            .setAlpha(0)
            .setInteractive({ cursor: 'pointer' }) // 👈 ici AVANT
            .on('pointerdown', () => {
                this.consigne2 && this.consigne2.setAlpha(0);

                maximize();
            });

        if (!this.imageRecherche.input) {
            this.imageRecherche.setInteractive({ cursor: 'pointer' });
        }

        this.tweens.add({
            targets: this.imageRecherche,
            scale: 1,
            alpha: 1,
            ease: 'Back.Out',
            duration: 500,
            delay: 100,
        });

        // 👇 Animation d’apparition "scale up + fade" au 1er affichage
        [container, descText, closeButton].forEach((el) => {
            el.setScale(0.5).setAlpha(0); // départ réduit + transparent
        });

        this.tweens.add({
            targets: [container, descText, closeButton],
            scale: 1,
            alpha: 1,
            ease: 'Back.Out', // effet pop doux
            duration: 500,
            onComplete: () => {
                this.input.enabled = true;
            },
        });
    }

    addPopupRecherche2() {
        this.imageRecherche.destroy();
        this.isDebriefActive = true;
        this.isAnimating = false;
        this.firstTime = true;
        const container = this.add
            .image(this.width / 2 - 823 / 2, this.height / 2, 'container-activite-4')
            .setOrigin(0, 0.5)
            .setDepth(1);

        this.imageRecherche = this.add
            .image(162 * this.scaleX + 80, this.height / 2 - 10, 'filetSelected')
            .setScale(1)
            .setOrigin(0.5)
            .setDepth(1);

        const descText = this.add
            .rexTagText(
                container.x + 823 / 2 - 130,
                container.y - container.height / 2 + 70,
                this.getText('Mission4', 'info2'),
                {
                    wordWrap: { width: 250 * 2 },
                    fontSize: Sizes.Text.p,
                    fontFamily: 'Monteserrat',
                    color: Colors.Text.Black,
                    backgroundColor: 'transparent',
                    tags: tags,
                    lineSpacing: 2,
                }
            )
            .setDepth(1);

        const closeButton = this.add
            .image(this.width / 2 - 8, 86 * 2, 'cta-close')
            .setOrigin(0.5)
            .setDepth(1);

        const minimize = () => {
            if (this.isAnimating) return;
            this.isAnimating = true;

            this.isDebriefActive = false;

            // Animation de disparition du popup
            this.tweens.add({
                targets: [closeButton, container, descText],
                alpha: 0,
                scale: 0,
                duration: 300,
                ease: 'Sine.easeInOut',
            });

            this.tweens.add({
                targets: this.imageRecherche,
                scale: 0.5,
                x: 64 + 54 * 2,
                y: this.height - 100,
                duration: 500,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                    this.imageRecherche.setInteractive({ cursor: 'pointer' });
                    this.isAnimating = false;

                    if (this.firstTime) {
                        this.launchActivities2();
                        this.firstTime = false;
                    }
                },
            });
        };

        const maximize = () => {
            if (this.isAnimating) return;
            this.isAnimating = true;

            this.tweens.add({
                targets: this.imageRecherche,
                scale: 1,
                x: 162 * this.scaleX + 80,
                y: this.height / 2 - 10,
                duration: 500,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                    this.tweens.add({
                        targets: [closeButton, container, descText],
                        scale: 1,
                        alpha: 1,
                        duration: 300,
                        ease: 'Sine.easeInOut',
                        onComplete: () => {
                            this.isAnimating = false; // Réactive le clic
                        },
                    });
                },
            });
        };

        closeButton.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            minimize();
        });

        this.imageRecherche
            .setScale(0.5)
            .setAlpha(0)
            .setInteractive({ cursor: 'pointer' }) // 👈 ici AVANT
            .on('pointerdown', maximize);

        if (!this.imageRecherche.input) {
            this.imageRecherche.setInteractive({ cursor: 'pointer' });
        }

        this.tweens.add({
            targets: this.imageRecherche,
            scale: 1,
            alpha: 1,
            ease: 'Back.Out',
            duration: 500,
            delay: 100,
        });

        // 👇 Animation d’apparition "scale up + fade" au 1er affichage
        [container, descText, closeButton].forEach((el) => {
            el.setScale(0.5).setAlpha(0); // départ réduit + transparent
        });

        this.tweens.add({
            targets: [container, descText, closeButton],
            scale: 1,
            alpha: 1,
            ease: 'Back.Out', // effet pop doux
            duration: 500,
            onComplete: () => {
                this.input.enabled = true;
            },
        });
    }

    addPopupRecherche3() {
        this.imageRecherche.destroy();
        this.isDebriefActive = true;
        this.isAnimating = false;
        this.firstTime = true;
        const container = this.add
            .image(this.width / 2 - 823 / 2, this.height / 2, 'container-activite-4')
            .setOrigin(0, 0.5)
            .setDepth(10);

        this.imageRecherche = this.add
            .image(162 * this.scaleX + 80, this.height / 2 - 10, 'fishSelected')
            .setScale(1)
            .setOrigin(0.5)
            .setDepth(11);

        const descText = this.add
            .rexTagText(
                container.x + 823 / 2 - 130,
                container.y - container.height / 2 + 70,
                this.getText('Mission4', 'info3'),
                {
                    wordWrap: { width: 520 },
                    fontSize: Sizes.Text.p,
                    fontFamily: 'Monteserrat',
                    color: Colors.Text.Black,
                    backgroundColor: 'transparent',
                    tags: tags,
                    lineSpacing: 2,
                }
            )
            .setDepth(10);

        const closeButton = this.add
            .image(this.width / 2 - 8, 86 * 2, 'cta-close')
            .setOrigin(0.5)
            .setDepth(10);

        this.consigne2 = this.add
            .rexTagText(
                this.width / 2,
                this.height / 2,
                this.getText('Mission4', 'consigneFleches'),
                {
                    align: 'center',
                    fontSize: '32px',
                    fontFamily: 'MonteserratBold',
                    color: Colors.Text.White,
                    backgroundColor: 'transparent',
                }
            )
            .setOrigin(0.5, 0.5)
            .setAlpha(0)
            .setDepth(5);

        const minimize = () => {
            if (this.isAnimating) return;
            this.isAnimating = true;

            this.isDebriefActive = false;

            // Animation de disparition du popup
            this.tweens.add({
                targets: [closeButton, container, descText],
                alpha: 0,
                scale: 0,
                duration: 300,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                    if (this.isFirstTime) {
                        this.consigne2 && this.consigne2.setAlpha(1);
                    }
                },
            });

            this.tweens.add({
                targets: this.imageRecherche,
                scale: 0.5,
                x: 64 + 54 * 2,
                y: this.height - 100,
                duration: 500,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                    this.imageRecherche.setInteractive({ cursor: 'pointer' });
                    this.isAnimating = false;

                    if (this.firstTime) {
                        this.launchActivities3();
                        this.firstTime = false;
                    }
                },
            });
        };

        const maximize = () => {
            if (this.isAnimating) return;
            this.isAnimating = true;

            this.tweens.add({
                targets: this.imageRecherche,
                scale: 1,
                x: 162 * this.scaleX + 80,
                y: this.height / 2 - 10,
                duration: 500,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                    this.tweens.add({
                        targets: [closeButton, container, descText],
                        scale: 1,
                        alpha: 1,
                        duration: 300,
                        ease: 'Sine.easeInOut',
                        onComplete: () => {
                            this.isAnimating = false; // Réactive le clic
                        },
                    });
                },
            });
        };

        closeButton.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            minimize();
        });

        this.imageRecherche
            .setScale(0.5)
            .setAlpha(0)
            .setInteractive({ cursor: 'pointer' }) // 👈 ici AVANT
            .on('pointerdown', maximize);

        if (!this.imageRecherche.input) {
            this.imageRecherche.setInteractive({ cursor: 'pointer' });
        }

        this.tweens.add({
            targets: this.imageRecherche,
            scale: 1,
            alpha: 1,
            ease: 'Back.Out',
            duration: 500,
            delay: 100,
        });

        // 👇 Animation d’apparition "scale up + fade" au 1er affichage
        [container, descText, closeButton].forEach((el) => {
            el.setScale(0.5).setAlpha(0); // départ réduit + transparent
        });

        this.tweens.add({
            targets: [container, descText, closeButton],
            scale: 1,
            alpha: 1,
            ease: 'Back.Out', // effet pop doux
            duration: 500,
            onComplete: () => {
                this.input.enabled = true;
            },
        });
    }

    launchActivities2() {
        this.allFishs = [];
        for (let i = 0; i < this.fishData.length; i++) {
            const element = this.fishData[i];
            let fish = new Fish(this, element.x, 280, i + 1).setAlpha(0);
            fish.setDepth(0);
            this.allFishs.push(fish);
            this.tweens.add({
                targets: fish,
                alpha: 1,
                duration: 500,
                ease: 'Back.Out',
                delay: i * 200,
            });
        }
        this.allTargest.forEach((el) => {
            el.destroy();
        });
        this.bouteilleActivite = this.add.image(
            this.width - 250,
            this.height - 70,
            'bouteille-vide-activite-2'
        );
        const icon1 = this.add.image(this.width - 250, this.height - 70, 'icone_inter');
        const icon2 = this.add.image(this.width - 300, this.height - 70, 'icone_inter');
        const icon3 = this.add
            .image(this.width - 350, this.height - 70, 'icone_check')
            .setScale(0.6);
        this.interIcons = [icon3, icon2, icon1];
        this.burgerMenu.destroy();
        this.addBurgerMenu(5);
    }

    launchActivities3() {
        this.finalContainer = this.add.container(this.width / 2, this.height / 2 - 300).setDepth(0);

        this.finalBackground = this.add.image(0, 0, 'backLabyrinthe').setOrigin(0.5).setScale(0.8);
        this.finalContainer.add(this.finalBackground);
        this.labyrinthe = this.add.image(0, 0, 'labyrinthe').setOrigin(0.5).setScale(0.8);
        this.finalContainer.add(this.labyrinthe);
        this.allClikable = [];
        this.clickableData.forEach((el) => {
            const clickable = this.add
                .image(el.x, el.y, el.illu)
                .setOrigin(0.5)
                .setScale(0.5)
                .setInteractive({ cursor: 'pointer' });
            clickable.on('pointerdown', () => {
                if (el.index === 2) {
                    this.addDebrief3(true);
                } else {
                    this.addDebrief3(false);
                }
            });
            this.finalContainer.add(clickable);
            this.allClikable.push(clickable);
        });

        this.allTargest.forEach((el) => {
            el.destroy();
        });
        this.bouteilleActivite = this.add.image(
            this.width - 250,
            this.height - 70,
            'bouteille-vide-activite-2'
        );
        const icon1 = this.add.image(this.width - 250, this.height - 70, 'icone_inter');
        const icon2 = this.add
            .image(this.width - 300, this.height - 70, 'icone_check')
            .setScale(0.6);
        const icon3 = this.add
            .image(this.width - 350, this.height - 70, 'icone_check')
            .setScale(0.6);
        this.interIcons = [icon3, icon2, icon1];
        this.addMoveCtrls();
        const navTitre = this.add.existing(
            new NavTitre(this, 200, 0, '4', this.getText('Mission4', 'titre'), this.scaleX)
        );

        navTitre.showWithAnimation();
        this.burgerMenu.destroy();
        this.addBurgerMenu(5);
    }

    addMoveCtrls() {
        const centerX = this.width / 2;
        const centerY = this.height / 2;
        const controlSize = 32;
        const offset = 20 + controlSize;
        this.controlUp = this.add
            .image(centerX, offset, 'fleche-activite-1')
            .setOrigin(0.5)
            .setRotation(Phaser.Math.DegToRad(-90))
            .setInteractive({ cursor: 'pointer' });

        this.controlUp.on('pointerdown', () => {
            if (this.isFirstTime) {
                this.consigne2 && this.consigne2.setAlpha(0);

                this.isFirstTime = false;
            }
            if (this.finalContainer.y < 770) {
                this.controlUp.disableInteractive();
                this.tweens.add({
                    targets: this.finalContainer,
                    y: this.finalContainer.y + 300,
                    duration: 500,
                    onComplete: () => {
                        this.controlUp.setInteractive({ cursor: 'pointer' });
                    },
                });
            }
        });

        this.controlDown = this.add
            .image(centerX, this.height - offset, 'fleche-activite-1')
            .setOrigin(0.5)
            .setRotation(Phaser.Math.DegToRad(90))
            .setInteractive({ cursor: 'pointer' });
        this.controlDown.on('pointerdown', () => {
            if (this.isFirstTime) {
                this.consigne2 && this.consigne2.setAlpha(0);

                this.isFirstTime = false;
            }
            if (this.finalContainer.y > -130) {
                this.controlDown.disableInteractive();
                this.tweens.add({
                    targets: this.finalContainer,
                    y: this.finalContainer.y - 300,
                    duration: 500,
                    onComplete: () => {
                        this.controlDown.setInteractive({ cursor: 'pointer' });
                    },
                });
            }
        });

        this.controlLeft = this.add
            .image(offset, centerY, 'fleche-activite-1')
            .setOrigin(0.5)
            .setRotation(Phaser.Math.DegToRad(180))
            .setInteractive({ cursor: 'pointer' });
        this.controlLeft.on('pointerdown', () => {
            if (this.isFirstTime) {
                this.consigne2 && this.consigne2.setAlpha(0);

                this.isFirstTime = false;
            }
            if (this.finalContainer.x < 1095) {
                this.controlLeft.disableInteractive();
                this.tweens.add({
                    targets: this.finalContainer,
                    x: this.finalContainer.x + 300,
                    duration: 500,
                    onComplete: () => {
                        this.controlLeft.setInteractive({ cursor: 'pointer' });
                    },
                });
            }
        });

        this.controlRight = this.add
            .image(this.width - offset, centerY, 'fleche-activite-1')
            .setOrigin(0.5)
            .setRotation(Phaser.Math.DegToRad(0))
            .setInteractive({ cursor: 'pointer' });
        this.controlRight.on('pointerdown', () => {
            if (this.isFirstTime) {
                this.consigne2.setAlpha(0);

                this.isFirstTime = false;
            }
            if (this.finalContainer.x > 395) {
                this.controlRight.disableInteractive();
                this.tweens.add({
                    targets: this.finalContainer,
                    x: this.finalContainer.x - 300,
                    duration: 500,
                    onComplete: () => {
                        this.controlRight.setInteractive({ cursor: 'pointer' });
                    },
                });
            }
        });
    }

    addDebrief(isCorrect) {
        this.isDebriefActive = true;

        const feedbackImage = this.add
            .existing(
                new AnswerFeedBack(
                    this,
                    this.width / 2,
                    this.height / 2,
                    isCorrect ? 'bonne-rep-activite-1' : 'mauvaise-rep-activite-1',
                    this.getText('Mission4', isCorrect ? 'bonneReponse' : 'mauvaiseReponse')
                )
            )
            .setDepth(10)
            .setScale(0)
            .setAlpha(0);

        this.tweens.add({
            targets: feedbackImage,
            scale: 1,
            alpha: 1,
            ease: 'Back.Out',
            duration: 500,
        });

        if (isCorrect) {
            const originalX = this.bouteilleActivite.x;
            const originalY = this.bouteilleActivite.y;

            this.time.delayedCall(1000, () => {
                this.tweens.add({
                    targets: feedbackImage,
                    scale: 0.5,
                    alpha: 0,
                    ease: 'Back.In',
                    duration: 400,
                    onComplete: () => {
                        feedbackImage.destroy();

                        this.allTargest = [
                            this.bouteilleActivite,
                            this.interIcons[0],
                            this.interIcons[1],
                            this.interIcons[2],
                        ];

                        this.tweens.add({
                            targets: this.allTargest,
                            x: (target) => {
                                if (target === this.bouteilleActivite) return this.width / 2;
                                const index = this.interIcons.indexOf(target);

                                return this.width / 2 - 120 + index * 50 * 1.2;
                            },
                            y: (target) => {
                                if (target === this.bouteilleActivite) return this.height / 2;
                                return this.height / 2;
                            },
                            scale: 1.2,
                            ease: 'Sine.easeInOut',
                            duration: 500,
                            hold: 500, // Attendre avant de continuer
                            onComplete: () => {
                                this.interIcons[0].setTexture('icone_check').setScale(0.7);

                                // ✅ Repartir ensemble après un délai
                                this.time.delayedCall(1000, () => {
                                    this.tweens.add({
                                        targets: this.allTargest,
                                        x: (target) => {
                                            if (target === this.bouteilleActivite) return originalX;
                                            const index = this.interIcons.indexOf(target);
                                            return originalX - 100 + index * 50;
                                        },
                                        y: originalY,
                                        scale: (target) =>
                                            this.interIcons.indexOf(target) === 0 ? 0.6 : 1,
                                        ease: 'Sine.easeInOut',
                                        duration: 500,
                                        onComplete: () => {
                                            this.allFilets.forEach((filet, index) => {
                                                this.tweens.add({
                                                    delay: index * 100,
                                                    targets: filet,
                                                    duration: 500,
                                                    scale: 0,
                                                    ease: 'Sine.easeInOut',
                                                    onComplete: () => {
                                                        filet.destroy();
                                                        if (index === this.allFilets.length - 1) {
                                                            this.secondScreen();
                                                        }
                                                    },
                                                });
                                            });
                                        },
                                    });
                                });
                            },
                        });
                    },
                });
            });
        } else {
            // ➡ Cas incorrect : classique
            this.time.delayedCall(1000, () => {
                this.tweens.add({
                    targets: feedbackImage,
                    scale: 0,
                    alpha: 0,
                    ease: 'Back.Out',
                    duration: 500,
                    onComplete: () => feedbackImage.destroy(),
                });

                // this.obsIcon.setTexture("question-icon-activite-1");
                this.isDebriefActive = false;
            });
        }
    }

    addDebrief2(isCorrect) {
        this.isDebriefActive = true;

        const feedbackImage = this.add
            .existing(
                new AnswerFeedBack(
                    this,
                    this.width / 2,
                    this.height / 2,
                    isCorrect ? 'bonne-rep-activite-1' : 'mauvaise-rep-activite-1',
                    this.getText('Mission4', isCorrect ? 'bonneReponse' : 'mauvaiseReponse')
                )
            )
            .setDepth(10)
            .setScale(0)
            .setAlpha(0);

        this.tweens.add({
            targets: feedbackImage,
            scale: 1,
            alpha: 1,
            ease: 'Back.Out',
            duration: 500,
        });

        if (isCorrect) {
            const originalX = this.bouteilleActivite.x;
            const originalY = this.bouteilleActivite.y;

            this.time.delayedCall(1000, () => {
                this.tweens.add({
                    targets: feedbackImage,
                    scale: 0.5,
                    alpha: 0,
                    ease: 'Back.In',
                    duration: 400,
                    onComplete: () => {
                        feedbackImage.destroy();

                        this.allTargest = [
                            this.bouteilleActivite,
                            this.interIcons[0],
                            this.interIcons[1],
                            this.interIcons[2],
                        ];

                        this.tweens.add({
                            targets: this.allTargest,
                            x: (target) => {
                                if (target === this.bouteilleActivite) return this.width / 2;
                                const index = this.interIcons.indexOf(target);

                                return this.width / 2 - 120 + index * 50 * 1.2;
                            },
                            y: (target) => {
                                if (target === this.bouteilleActivite) return this.height / 2;
                                return this.height / 2;
                            },
                            scale: (target) => {
                                const index = this.interIcons.indexOf(target);
                                if (index === 0) return 0.7;
                                return 1.2;
                            },
                            ease: 'Sine.easeInOut',
                            duration: 500,
                            hold: 500, // Attendre avant de continuer
                            onComplete: () => {
                                this.interIcons[1].setTexture('icone_check').setScale(0.7);

                                // ✅ Repartir ensemble après un délai
                                this.time.delayedCall(1000, () => {
                                    this.tweens.add({
                                        targets: this.allTargest,
                                        x: (target) => {
                                            if (target === this.bouteilleActivite) return originalX;
                                            const index = this.interIcons.indexOf(target);
                                            return originalX - 100 + index * 50;
                                        },
                                        y: originalY,
                                        scale: (target) => {
                                            if (target === this.bouteilleActivite) return 1;
                                            const index = this.interIcons.indexOf(target);
                                            if (index === 0 || index === 1) return 0.6;
                                            return 1;
                                        },
                                        ease: 'Sine.easeInOut',
                                        duration: 500,
                                        onComplete: () => {
                                            this.allFishs.forEach((fish, index) => {
                                                this.tweens.add({
                                                    delay: index * 100,
                                                    targets: fish,
                                                    duration: 500,
                                                    scale: 0,
                                                    ease: 'Sine.easeInOut',
                                                    onComplete: () => {
                                                        fish.destroy();
                                                        if (index === this.allFishs.length - 1) {
                                                            this.thirdScreen();
                                                        }
                                                    },
                                                });
                                            });
                                        },
                                    });
                                });
                            },
                        });
                    },
                });
            });
        } else {
            // ➡ Cas incorrect : classique
            this.time.delayedCall(1000, () => {
                this.tweens.add({
                    targets: feedbackImage,
                    scale: 0,
                    alpha: 0,
                    ease: 'Back.Out',
                    duration: 500,
                    onComplete: () => feedbackImage.destroy(),
                });
                this.isDebriefActive = false;
            });
        }
    }

    addDebrief3(isCorrect) {
        this.isDebriefActive = true;

        const feedbackImage = this.add
            .existing(
                new AnswerFeedBack(
                    this,
                    this.width / 2,
                    this.height / 2,
                    isCorrect ? 'bonne-rep-activite-1' : 'mauvaise-rep-activite-1',
                    this.getText('Mission4', isCorrect ? 'bonneReponse' : 'mauvaiseReponse')
                )
            )
            .setDepth(10)
            .setScale(0)
            .setAlpha(0);

        this.tweens.add({
            targets: feedbackImage,
            scale: 1,
            alpha: 1,
            ease: 'Back.Out',
            duration: 500,
        });

        if (isCorrect) {
            const originalX = this.bouteilleActivite.x;
            const originalY = this.bouteilleActivite.y;

            this.time.delayedCall(1000, () => {
                this.tweens.add({
                    targets: feedbackImage,
                    scale: 0.5,
                    alpha: 0,
                    ease: 'Back.In',
                    duration: 400,
                    onComplete: () => {
                        feedbackImage.destroy();

                        this.allTargest = [
                            this.bouteilleActivite,
                            this.interIcons[0],
                            this.interIcons[1],
                            this.interIcons[2],
                        ];

                        this.tweens.add({
                            targets: this.allTargest,
                            x: (target) => {
                                if (target === this.bouteilleActivite) return this.width / 2;
                                const index = this.interIcons.indexOf(target);
                                return this.width / 2 - 120 + index * 50 * 1.2;
                            },
                            y: (target) => {
                                if (target === this.bouteilleActivite) return this.height / 2;
                                return this.height / 2;
                            },
                            scale: (target) => {
                                const index = this.interIcons.indexOf(target);
                                if (index === 0 || index === 1) return 0.7;
                                return 1.2;
                            },
                            ease: 'Sine.easeInOut',
                            duration: 500,
                            hold: 500, // Attendre avant de continuer
                            onComplete: () => {
                                this.interIcons[2].setTexture('icone_check').setScale(0.7);

                                // ✅ Repartir ensemble après un délai
                                this.time.delayedCall(1000, () => {
                                    this.tweens.add({
                                        targets: this.allTargest,
                                        x: (target) => {
                                            if (target === this.bouteilleActivite) return originalX;
                                            const index = this.interIcons.indexOf(target);
                                            return originalX - 100 + index * 50;
                                        },
                                        y: originalY,
                                        scale: (target) => {
                                            if (target === this.bouteilleActivite) return 1;
                                            return 0.6;
                                        },
                                        ease: 'Sine.easeInOut',
                                        duration: 500,
                                        onComplete: () => {
                                            this.allTargest.forEach((target) => {
                                                target.destroy();
                                            });
                                            this.allClikable.forEach((target) => {
                                                target.destroy();
                                            });
                                            this.imageRecherche.destroy();
                                            this.showEndScreen();
                                        },
                                    });
                                });
                            },
                        });
                    },
                });
            });
        } else {
            // ➡ Cas incorrect : classique
            this.time.delayedCall(1000, () => {
                this.tweens.add({
                    targets: feedbackImage,
                    scale: 0,
                    alpha: 0,
                    ease: 'Back.Out',
                    duration: 500,
                    onComplete: () => feedbackImage.destroy(),
                });
                this.isDebriefActive = false;
            });
        }
    }

    secondScreen() {
        this.addPopupRecherche2();
    }

    thirdScreen() {
        this.addPopupRecherche3();
    }

    addActivite() {
        this.UiActivite = [];
        this.missionData.filetsPositions.forEach((pos, index) => {
            // Now you have access to the index of each filet
            const imageFilet = this.add
                .image(pos.x, pos.y, `filet-${index + 1}`)
                .setOrigin(0.5)
                .setScale(1.5);
            imageFilet.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
                if (index + 1 === 2) {
                    this.addDebrief(true);
                } else {
                    this.addDebrief(false);
                }
            });
            this.allFilets.push(imageFilet);
            this.UiActivite.push(imageFilet);
        });

        this.bouteilleActivite = this.add.image(
            this.width - 250,
            this.height - 70,
            'bouteille-vide-activite-2'
        );
        const icon1 = this.add.image(this.width - 250, this.height - 70, 'icone_inter');
        const icon2 = this.add.image(this.width - 300, this.height - 70, 'icone_inter');
        const icon3 = this.add.image(this.width - 350, this.height - 70, 'icone_inter');

        this.interIcons = [icon3, icon2, icon1];

        this.UiActivite.push(
            this.bouteilleActivite,
            this.interIcons[0],
            this.interIcons[1],
            this.interIcons[2]
        );

        this.UiActivite.forEach((el) => {
            el.setScale(0).setAlpha(0);
        });

        this.UiActivite.forEach((el, index) => {
            let targetScale = 1;
            // If it's a filet image, keep scale at 1.5
            if (index < this.missionData.filetsPositions.length) {
                targetScale = 1.5;
            }
            this.tweens.add({
                targets: el,
                scale: targetScale,
                alpha: 1,
                duration: 500,
                delay: index * 100,
                ease: 'Back.Out',
                onComplete: () => {
                    if (index === this.UiActivite.length - 1) {
                        // Last element animation complete
                        this.input.enabled = true;
                    }
                },
            });
        });
        this.addBurgerMenu(5);
    }

    showEndScreen() {
        const duration = 500;
        const elements = [];
        if (this.game.data.level === 0) {
            this.bouteilleActivite.destroy();
        }
        const blocker = this.add.rectangle(
            this.width / 2,
            this.height / 2,
            this.width,
            this.height,
            Colors.Elmt.Beige,
            1
        );

        // Nav (titre-nav-activite-1) – commence plus haut
        const navTitre = this.add.existing(
            new NavTitre(this, 200, 0, '4', this.getText('Mission4', 'titre'), this.scaleX)
        );

        navTitre.showWithAnimation();

        // ➡️ Titre avec animation spéciale
        const title = this.add
            .text(this.width / 2, this.height / 2 - 220, this.getText('Mission4', 'endTitre'), {
                fontSize: Sizes.Text.h1,
                color: Colors.Text.BleuNovotel,
                fontFamily: 'Binx',
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0);

        // ➡️ Autres éléments à animer ensuite
        const text1 = this.add
            .text(this.width / 2, this.height / 2 - 150, this.getText('Mission4', 'endTexte1'), {
                fontSize: Sizes.Text.p,
                color: Colors.Text.DarkBlue,
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0.5);

        this.addBouteille('Mission4');

        const icone = this.add
            .image(this.width / 2 - 390, this.height / 2 + 190, 'attention')
            .setAlpha(0)
            .setScale(0.5);

        const text2 = this.add
            .text(this.width / 2, this.height / 2 + 200, this.getText('Mission4', 'endTexte2'), {
                fontSize: Sizes.Text.p,
                color: Colors.Text.DarkBlue,
                fontFamily: 'Monteserrat',
                align: 'center',
                wordWrap: { width: 368 * 2 },
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0.5);

        elements.push(text1, this.bouteille, this.textBouteille, icone, text2);

        // ➡️ Bouton
        const button = this.add
            .existing(
                new ButtonRounded(
                    this,
                    this.width - 64 - 64,
                    this.height - 32 - 32,
                    86 * 2,
                    32 * 2,
                    this.getText('Mission4', 'buttonLabel1'),
                    Colors.Text.White,
                    Colors.Elmt.BleuNovotel,
                    false,
                    Colors.Text.White,
                    true,
                    false,
                    'arrow-right-white',
                    null
                )
            )
            .setAlpha(0)
            .setScale(0.5);

        elements.push(button);

        button.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            this.scene.start('End');
        });

        // ➡️ Animation du titre : scale up + down + fade in
        this.tweens.add({
            targets: title,
            alpha: 1,
            scale: 1.2,
            duration: duration,
            ease: 'Back.Out',
            onComplete: () => {
                // ➡️ Retour à scale 1 (rebond)
                this.tweens.add({
                    targets: title,
                    scale: 1,
                    duration: 300,
                    ease: 'Back.Out',
                    onComplete: () => {
                        // ➡️ Quand le titre est fini : animer les autres éléments en cascade
                        elements.forEach((el, index) => {
                            this.tweens.add({
                                targets: el,
                                alpha: 1,
                                scale: 1,
                                ease: 'Back.Out',
                                duration: duration,
                                delay: index * 150,
                            });
                        });
                        this.input.enabled = true;
                    },
                });
            },
        });
    }
}
